import _ from 'underscore';

export default class OfferSidebarMenu {
  constructor($scope, OfferSidebarService) {
    var menu = [
      {
        group: 0,
        title: 'Overview',
        pages: [{
          title: 'Overview',
          action: 'edit_overview'
        }]
      },
      {
        group: 0,
        title: 'Main Details',
        pages: [
          {
            title: 'Title & Synopsis',
            action: 'edit_main_title'
          },
          {
            title: 'Basic Infos',
            action: 'edit_main_basic'
          },
          {
            title: 'Description',
            action: 'edit_main_description',
          },
          {
            title: 'Stocklist',
            action: 'edit_main_stocklist'
          },
          {
            title: 'Connected/Related Offers',
            action: 'edit_main_connections'
          }
        ]
      },
      {
        group: 0,
        title: 'Special Sections',
        pages: [
          {
            title: 'Tags & Keywords',
            action: 'edit_sections_tags'
          },
          {
            title: 'Specs & Attachments',
            action: 'edit_sections_specs'
          },
          {
            title: 'Images',
            action: 'edit_sections_images'
          },
          {
            title: 'Offers Combination',
            action: 'edit_sections_offers'
          }
        ]
      },
      {
        group: 0,
        title: 'Market Restrictions',
        pages: [{
          title: 'Market Restrictions',
          action: 'edit_market'
        }]
      },
      {
        group: 1,
        title: 'Prices & Charges',
        pages: [{
          title: 'Prices & Charges',
          action: 'edit_prices'
        }]
      },
      {
        group: 1,
        title: 'OSPP Users',
        pages: [{
          title: 'OSPP Users',
          action: 'edit_ospp_users'
        }]
      },
      {
        group: 1,
        title: 'User Pricing',
        pages: [{
          title: 'User Pricing',
          action: 'edit_user_pricing'
        }]
      },
      {
        group: 1,
        title: 'Supplier Pricing',
        pages: [{
          title: 'Supplier Pricing',
          action: 'edit_supplier_pricing'
        }]
      },
      {
        group: 1,
        title: 'Cut Pricing',
        pages: [{
          title: 'Cut Pricing',
          action: 'edit_cut_pricing'
        }]
      },
      {
        group: 2,
        title: 'Matching',
        pages: [{
          title: 'Matching',
          action: 'edit_matching'
        }]
      },
      {
        group: 3,
        title: 'FAQs',
        pages: [{
          title: 'FAQ Items',
          action: 'edit_faq'
        }]
      },
      {
        group: 3,
        title: 'Roll Bar Themes',
        pages: [{
          title: 'Roll Bar Themes',
          action: 'edit_themes'
        }]
      },
      {
        group: 3,
        title: 'Requests & Orders',
        pages: [
          {
            title: 'Requests',
            action: 'edit_requests'
          },
          {
            title: 'Orders',
            action: 'edit_orders'
          }
        ]
      },
      {
        group: 3,
        title: 'Reports & Stats',
        pages: [{
          title: 'Reports & Stats',
          action: 'edit_reports'
        }]
      },
      {
        group: 3,
        title: 'Special Notes',
        pages: [{
          title: 'Special Notes',
          action: 'edit_notes'
        }]
      },
      {
        group: 4,
        title: 'Campaigns',
        pages: [
          {
            title: 'Campaigns',
            action: 'edit_campaigns'
          },
          {
            title: 'Campaign Settings',
            action: 'edit_campaign_settings'
          },
          {
            title: 'Campaign Basic Infos',
            action: 'edit_campaign_basic_infos'
          }
        ]
      }
    ];

    $scope.set_page_data = function(section_index, page_index, data) {
      var section = $scope.menu[section_index];
      var page = section.pages[page_index];
      page.data = data;
    };

    $scope.$on('set_sidebar_data', function(event, data) {
      $scope.set_page_data(data[0], data[1], data[2]);
    });

    function set_menu() {
      var section = _.find(menu, function(section) {
        return _.contains(_.pluck(section.pages, 'action'), window.app_data.action);
      });

      if (section) {
        $scope.menu = _.where(menu, {
          group: section.group
        });
        var groups_with_data = [0];
        if (_.contains(groups_with_data, section.group)) {
          OfferSidebarService.get_sidebar_data(window.app_data.offer_id, section.group).success(function(data) {
            var sidebar_data = data.sidebar_data;
            if (section.group === 0) {
              $scope.set_page_data(1, 0, [{
                type: 'percentage',
                value: sidebar_data.title_percentage
              }, null]);
              $scope.set_page_data(1, 1, [{
                type: 'percentage',
                value: sidebar_data.basic_percentage
              }, null]);
              $scope.set_page_data(1, 2, [{
                type: 'percentage',
                value: sidebar_data.description_percentage
              }, null]);
              $scope.set_page_data(1, 3, [{
                type: 'icon',
                value: sidebar_data.stocklist_count
              }, {
                type: 'percentage',
                value: sidebar_data.stocklist_percentage,
                hide: sidebar_data.stocklist_count === 0
              }]);
              $scope.set_page_data(1, 4, [{
                type: 'counter',
                value: sidebar_data.connected.count,
                hide: sidebar_data.connected.count === 0
              }, {
                type: 'counter',
                value: sidebar_data.connected.general_count,
                hide: sidebar_data.connected.count === 0
              }, {
                type: 'counter',
                value: sidebar_data.connected.personalized_count,
                hide: sidebar_data.connected.count === 0
              }]);
              $scope.set_page_data(2, 0, [{
                type: 'percentage',
                value: sidebar_data.tags_percentage
              }, null]);
              $scope.set_page_data(2, 1, [{
                type: 'counter',
                value: sidebar_data.specs_count,
                hide: sidebar_data.specs_count === 0
              }, null]);
              $scope.set_page_data(2, 2, [{
                type: 'counter',
                value: sidebar_data.images_count,
                hide: sidebar_data.images_count === 0
              }, null]);
              $scope.set_page_data(3, 0, [{
                type: 'counter',
                value: sidebar_data.restrictions_count
              }, null]);
            }
          });
        }
      }
    }

    $scope.init = function() {
      $scope.menu = [];
      set_menu();
    };

    $scope.init();
  }
}

OfferSidebarMenu.$inject = ['$scope', 'OfferSidebarService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/offer-sidebar-menu.ctrl.js